import sample_1 from './nug.jpeg';

export const nugImpressions = {
    sample_1,
};
